var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('FormLoader'):_c('EditBranchForm',{attrs:{"isSubmitting":_vm.isSubmitting,"selectedBranch":_vm.selectedBranch},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }